import style from './Header.module.scss';
import Image from 'next/image';
import Link from 'next/link';

const HeaderContent = () => {
  return (
    <div className="d-flex justify-content-around  my-3 ">
      <Link href="/me/coin-friends" className={style.coinActionBtn}>
        <Image
          src="https://womophoto.s3.ap-northeast-1.amazonaws.com/public/assets/images/icon/quick_btn_give.svg?v=2"
          alt="支持朋友"
          width={24}
          height={24}
        />
        <span className="ms-1 fs-sm-1">打賞朋友</span>
      </Link>

      <Link href="/me/coin-passbook" className={style.coinActionBtn}>
        <Image
          src="https://womophoto.s3.ap-northeast-1.amazonaws.com/public/assets/images/icon/quick_btn_get.svg?v=2"
          alt="籌碼存摺"
          width={24}
          height={24}
        />
        <span className="ms-1 fs-sm-1">籌碼存摺</span>
      </Link>
    </div>
  );
};

export default HeaderContent;
